var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9822 8C9.6409 8 8.55359 9.08731 8.55359 10.4286C8.55359 11.7698 9.6409 12.8571 10.9822 12.8571C12.3234 12.8571 13.4107 11.7698 13.4107 10.4286C13.4107 9.08731 12.3234 8 10.9822 8ZM6.55359 10.4286C6.55359 7.98274 8.53633 6 10.9822 6C13.428 6 15.4107 7.98274 15.4107 10.4286C15.4107 12.8744 13.428 14.8571 10.9822 14.8571C8.53633 14.8571 6.55359 12.8744 6.55359 10.4286Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9822 14.8571C8.69412 14.8571 6.83929 16.712 6.83929 19C6.83929 19.5523 6.39158 20 5.83929 20C5.28701 20 4.83929 19.5523 4.83929 19C4.83929 15.6074 7.58955 12.8571 10.9822 12.8571C14.3748 12.8571 17.125 15.6074 17.125 19C17.125 19.5523 16.6773 20 16.125 20C15.5727 20 15.125 19.5523 15.125 19C15.125 16.712 13.2702 14.8571 10.9822 14.8571Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83929 8.85715C5.4448 8.85715 5.125 9.17694 5.125 9.57143C5.125 9.96592 5.4448 10.2857 5.83929 10.2857C6.23378 10.2857 6.55357 9.96592 6.55357 9.57143C6.55357 9.17694 6.23378 8.85715 5.83929 8.85715ZM3.125 9.57143C3.125 8.07237 4.34023 6.85715 5.83929 6.85715C7.33834 6.85715 8.55357 8.07237 8.55357 9.57143C8.55357 11.0705 7.33834 12.2857 5.83929 12.2857C4.34023 12.2857 3.125 11.0705 3.125 9.57143Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83929 12.2857C4.97141 12.2857 4.26788 12.9893 4.26788 13.8571C4.26788 14.4094 3.82017 14.8571 3.26788 14.8571C2.7156 14.8571 2.26788 14.4094 2.26788 13.8571C2.26788 11.8847 3.86684 10.2857 5.83929 10.2857C7.81173 10.2857 9.41074 11.8847 9.41074 13.8571C9.41074 14.4094 8.96303 14.8571 8.41074 14.8571C7.85846 14.8571 7.41074 14.4094 7.41074 13.8571C7.41074 12.9893 6.70716 12.2857 5.83929 12.2857Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.125 7C22.125 7.55228 21.6773 8 21.125 8L17.125 8C16.5727 8 16.125 7.55228 16.125 7C16.125 6.44772 16.5727 6 17.125 6L21.125 6C21.6773 6 22.125 6.44772 22.125 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupRemove);
export default __webpack_public_path__ + "static/media/group-remove.8926dad390eebebcc03f9d6146e8e9d0.svg";
export { ForwardRef as ReactComponent };